import { SignupEmbedder } from 'signup-embedder';
import { getIsNewUserExperiment } from '../../experiments/ExperimentUtils';
import { getIsGoogleCredentialAuthentication } from '../../google-authentication/google-prompt/getIsGoogleCredentialAuthentication';
import { getIsMobile } from '../deviceUtils';
import { getFlowKey } from '../../routing/getFlowKey';
import { getIsOAuthExistingUser } from '../../store/app/selectors';
import { Flow } from 'signup-constants/Flow';
export const SU0004_PRODUCTISED_FLOWS = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service, Flow.Commerce];

/**
 * Part of the SU-0004 productisation.
 * Returns true when the user is eligible for the productised signup flow:
 * new user, not Google-authed, not on mobile, and not embedded.
 */
export const isProductisedSignupFlow = state => {
  const isEligibleFlow = SU0004_PRODUCTISED_FLOWS.includes(getFlowKey());
  if (!isEligibleFlow) {
    return false;
  }
  return getIsNewUserExperiment(state) && !getIsOAuthExistingUser(state) && !getIsGoogleCredentialAuthentication(state) && !getIsMobile() && !SignupEmbedder.isActive();
};